module.exports = __webpack_public_path__ + "img/kr-product-content1-img-3.76c8e7b.png";